/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UserHistoryDrawerContainer_settings = {
    readonly organization: {
        readonly name: string;
    };
    readonly " $fragmentRefs": FragmentRefs<"RecentHistoryContainer_settings" | "UserStatusChangeContainer_settings">;
    readonly " $refType": "UserHistoryDrawerContainer_settings";
};
export type UserHistoryDrawerContainer_settings$data = UserHistoryDrawerContainer_settings;
export type UserHistoryDrawerContainer_settings$key = {
    readonly " $data"?: UserHistoryDrawerContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"UserHistoryDrawerContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserHistoryDrawerContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RecentHistoryContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserStatusChangeContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '26fd70e7fc4bdb0aed1e72848d47df58';
export default node;
